import React from 'react';

const DestinationsList = ({ destinations, onDelete, onEdit }) => {
  const getDestinationIcon = (type) => {
    switch (type) {
      case 'slack':
        return '🔔'; // Slack bell icon
      case 'webhook':
        return '🔗'; // Link icon
      case 'googleSheets':
        return '📊'; // Chart icon
      default:
        return '📡'; // Generic antenna icon
    }
  };

  const getDestinationDetails = (destination) => {
    switch (destination.type) {
      case 'slack':
        return {
          title: 'Slack Webhook',
          detail: `${destination.config.webhookUrl ? 'Configured' : 'Missing webhook URL'}`,
        };
      case 'webhook':
        return {
          title: 'Generic Webhook',
          detail: destination.config.url || 'No URL configured',
        };
      case 'googleSheets':
        return {
          title: 'Google Sheets',
          detail: destination.config.spreadsheetId
            ? `Spreadsheet: ${destination.config.spreadsheetId}`
            : 'No spreadsheet ID configured',
        };
      default:
        return {
          title: 'Unknown Destination',
          detail: 'Details not available',
        };
    }
  };

  const getBadgeColor = (type) => {
    switch (type) {
      case 'slack':
        return 'bg-purple-100 text-purple-800';
      case 'webhook':
        return 'bg-blue-100 text-blue-800';
      case 'googleSheets':
        return 'bg-green-100 text-green-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  if (!destinations || destinations.length === 0) {
    return (
      <div className="text-center py-8 bg-gray-50 rounded-md">
        <p className="text-gray-500">No destinations configured yet</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {destinations.map((destination) => {
        const { title, detail } = getDestinationDetails(destination);
        return (
          <div key={destination._id} className="card">
            <div className="flex justify-between">
              <div className="flex space-x-3">
                <div className="text-2xl">{getDestinationIcon(destination.type)}</div>
                <div>
                  <div className="flex items-center space-x-2">
                    <h3 className="font-medium">{title}</h3>
                    <span
                      className={`px-2 py-0.5 rounded-full text-xs font-medium ${getBadgeColor(
                        destination.type
                      )}`}
                    >
                      {destination.type}
                    </span>
                    {destination.active ? (
                      <span className="bg-green-100 text-green-800 text-xs px-2 py-0.5 rounded-full">
                        Active
                      </span>
                    ) : (
                      <span className="bg-gray-100 text-gray-800 text-xs px-2 py-0.5 rounded-full">
                        Inactive
                      </span>
                    )}
                  </div>
                  <p className="text-sm text-gray-600 mt-1">{detail}</p>
                </div>
              </div>
              <div className="flex space-x-4">
                <button
                  onClick={() => onEdit(destination)}
                  className="text-blue-600 hover:text-blue-800"
                  aria-label="Edit destination"
                >
                  Edit
                </button>
                <button
                  onClick={() => onDelete(destination._id)}
                  className="text-red-600 hover:text-red-800"
                  aria-label="Delete destination"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DestinationsList;